export const formTypes = {
    AddCost: '[Orders] Add cost',
    AugmentIdTemporary: '[Orders] Aument id'}